import axios from 'axios';
import { to } from 'await-to-js';

const { REACT_APP_API_URL } = process.env;

export async function obtenerTicketMicroSitio(payload) {
    const [error, response] = await to(axios.post(`${REACT_APP_API_URL}/administrador/micro-sitio/obtener-ticket`, payload));

    if (error) {
        return {
            status: false,
            mensaje: 'Ocurrio un error al conectar con el servidor',
        };
    }

    return response.data;
}
